import { render, staticRenderFns } from "./BonDeLivraisonItem.vue?vue&type=template&id=721ef2ad&scoped=true&"
import script from "./BonDeLivraisonItem.vue?vue&type=script&lang=js&"
export * from "./BonDeLivraisonItem.vue?vue&type=script&lang=js&"
import style0 from "./BonDeLivraisonItem.vue?vue&type=style&index=0&id=721ef2ad&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721ef2ad",
  null
  
)

export default component.exports